export const STARTUP_PROFILE_ACTIONS = {
    EDIT_STARTUP_PROFILE: "EDIT_STARTUP_PROFILE",
};

export const STARTUP_PROFILE_INDUSTRIES = [
    { label: "FinTech", value: "FinTech" },
    { label: "HealthTech", value: "HealthTech" },
    { label: "EduTech", value: "EduTech" },
];
